import {
  GetPinByAddressQuery,
  GetPinByAddressQueryVariables,
} from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import GET_PIN_BY_ADDRESS from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/location/getPinByAddress.graphql';
import { useQuery } from '@apollo/client';

export const useGetPinByAddress = (address: string) =>
  useQuery<GetPinByAddressQuery, GetPinByAddressQueryVariables>(
    GET_PIN_BY_ADDRESS,
    {
      skip: !address,
      variables: {
        address,
      },
    },
  );
